import { ColumnFactory, ComponentManager } from "radpresentation.htmlclient.defaultviewextensions";

export default class ProgressBarColumnFactory extends ColumnFactory {
    constructor(params: any) {
        super(params);
    }

    public getValue(): any {
        let roundedValue = Math.round(this.raw * 100);
        let html = '<div class="progress"><div class="progress-bar"style="width:' + roundedValue + '%">' + roundedValue + '%</div></div>';
        return html;
    }
}

ComponentManager.setFactory('ProgressBarColumn', ProgressBarColumnFactory, 'WorkflowEngineHTMLViewExtension');